module.exports = __webpack_public_path__ + "956d9f415a5781ee5a2158a98f07548c.woff";